<section class="mt-3">
  <div class="d-flex justify-content-between align-items-center">
    <h3>Hospital Assessment &amp; Questionnaire</h3>
    <button *ngIf="!form" mat-raised-button color="primary" (click)="startNew()">
      <mat-icon>add</mat-icon>&nbsp;New Assessment
    </button>
  </div>

  <!-- Add / edit form -->
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="save()" class="p-2" style="border:1px solid #ddd;border-radius:8px">
    <h4>{{ editing ? 'Edit Assessment' : 'New Assessment' }}</h4>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Assessment Date</mat-label>
          <input matInput [matDatepicker]="assessmentPicker" formControlName="assessmentDate" [max]="today" readonly
                 (click)="assessmentPicker.open()">
          <mat-datepicker-toggle matSuffix [for]="assessmentPicker"></mat-datepicker-toggle>
          <mat-datepicker #assessmentPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Assessed By</mat-label>
          <input matInput formControlName="assessedBy">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div *ngFor="let q of questions; let i = index" [ngClass]="q.type === 'textarea' ? 'col-md-12' : 'col-md-6'">
      <ng-container [ngSwitch]="q.type">
        <mat-form-field *ngSwitchCase="'text'" appearance="outline" class="w-100">
          <mat-label>{{ i + 1 }}. {{ q.label }}</mat-label>
          <input matInput [formControlName]="q.key">
        </mat-form-field>
        <mat-form-field *ngSwitchCase="'number'" appearance="outline" class="w-100">
          <mat-label>{{ i + 1 }}. {{ q.label }}</mat-label>
          <input matInput type="number" min="0" [formControlName]="q.key">
        </mat-form-field>
        <mat-form-field *ngSwitchCase="'textarea'" appearance="outline" class="w-100">
          <mat-label>{{ i + 1 }}. {{ q.label }}</mat-label>
          <textarea matInput rows="3" [formControlName]="q.key"></textarea>
        </mat-form-field>
        <mat-form-field *ngSwitchCase="'yesno'" appearance="outline" class="w-100">
          <mat-label>{{ i + 1 }}. {{ q.label }}</mat-label>
          <mat-select [formControlName]="q.key">
            <mat-option value="Yes">Yes</mat-option>
            <mat-option value="No">No</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngSwitchCase="'select'" appearance="outline" class="w-100">
          <mat-label>{{ i + 1 }}. {{ q.label }}</mat-label>
          <mat-select [formControlName]="q.key">
            <mat-option *ngFor="let o of q.options" [value]="o">{{ o }}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2">
      <button mat-button type="button" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || saving">Save</button>
    </div>
  </form>

  <p *ngIf="!form && !assessments.length" class="text-muted mt-2">No assessments recorded yet.</p>

  <!-- Saved assessments -->
  <mat-card *ngFor="let a of assessments" class="mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <strong>{{ a.assessmentDate | date: 'mediumDate' }}</strong>
        <span class="text-muted"> · Assessed by {{ a.assessedBy }}</span>
      </div>
      <div>
        <button mat-button (click)="toggleLog(a)">
          Change log ({{ a.changeLog.length }})
        </button>
        <button mat-icon-button color="primary" (click)="edit(a)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
      </div>
    </div>

    <table style="width:100%;border:1px solid #ddd;border-collapse:collapse;margin-top:8px">
      <tr *ngFor="let q of questions; let i = index">
        <th style="width:50%;border:1px solid #ddd;padding:6px;text-align:left">{{ i + 1 }}. {{ q.label }}</th>
        <td style="border:1px solid #ddd;padding:6px;white-space:pre-line">{{ answerFor(a, q) ?? '—' }}</td>
      </tr>
    </table>

    <div *ngIf="expandedKey === a.key" class="mt-2">
      <h4>Change Log</h4>
      <p *ngIf="!a.changeLog.length" class="text-muted">No changes since this assessment was created.</p>
      <div *ngFor="let log of a.changeLog.slice().reverse()" class="mb-2">
        <div class="small text-muted">{{ log.changedAt | date: 'medium' }} · {{ log.changedBy }}</div>
        <ul class="mb-0">
          <li *ngFor="let c of log.changes">
            <strong>{{ c.question }}:</strong> {{ c.from || '—' }} → {{ c.to || '—' }}
          </li>
        </ul>
      </div>
    </div>
  </mat-card>
</section>
